import React, { useRef, useEffect, useState } from 'react';
import ProTable from '@ant-design/pro-table';

import {
  Button,
  Space,
  Input,
  message,
  Row,
  Col,
  Divider,
  Popconfirm,
  Modal,
} from 'antd';

import DebounceSelect from '@/components/DebounceSelect';
import {
  queryLittaGoodsInfoList,
  apiGoodsList,
  apiGoodsAdd,
  apiGoodsDel,
} from '@/services/promotion';
import { guuid } from '@/utils/utils';



const channelConfigPage = (props) => {
  const { visible, setVisible } = props;

  const cdkeyActionRef = useRef();
  const [cdkeyAddVisable, setCdkeyAddVisable] = useState(false);
  const actionRefCdkeyKeyword = useRef(null);
  const actionRefCdkeyCode = useRef(null);
  const [allActivitylist, setAllActivityList] = useState([]);

  useEffect(() => {
    // queryAllActivityList();
    fetchUserList().then((newOptions) => {
      setAllActivityList(newOptions);
    });
  }, []);

  // 请求
  async function fetchUserList(redeemName) {
    return queryLittaGoodsInfoList({
      requestData: { goodsName: redeemName, tenantType: 1 },
      page: {
        currentPage: 1,
        pageSize: 20,
      },
    }).then((body) =>
      body?.data?.map((item) => {
        return {
          label: `【${item.id}】${item.goodsDetailName}  ${item.salePriceInfo}元`,
          value: item.skuId,
        };
      }),
    );
  }

  const bindCdkey = () => {
    apiGoodsAdd({
      requestData: {
        packageType: actionRefCdkeyKeyword?.current?.trim(),
        skuId: actionRefCdkeyCode.current,
      },
    }).then(({ code, msg }) => {
      if (code === '00000') {
        message.success('绑定成功');

        cdkeyActionRef.current.reloadAndRest();
      } else {
        message.error(msg);
      }
    });
  };

  const deleteCdkey = (id) => {
    apiGoodsDel({
      requestData: {
        id: id,
      },
    }).then(({ code, msg }) => {
      if (code === '00000') {
        message.success('删除成功');
        cdkeyActionRef.current.reload();
      } else {
        message.error(msg);
      }
    });
  };

  const cdkeyColumnsPop = [
    {
      title: 'packageType',
      dataIndex: 'packageType',
      valueType: 'select',
    },
    {
      title: '商品ID&名称',
      dataIndex: 'id',
      valueType: 'select',
      render: (_, record, index) => {
        const { goodsId, goodsName, salePriceStr, combineTypeName } = record;
        return (
          <div>{`【${goodsId}】【${combineTypeName}】${goodsName}  ${salePriceStr}元`}</div>
        );
      },
    },
    {
      title: '操作',
      dataIndex: 'templateName',
      valueType: 'input',
      align: 'center',
      render: (_, record, index) => {
        return (
          <Space>
            <Popconfirm
              title={'确认要删除吗？'}
              onConfirm={() => {
                deleteCdkey(record?.id);
              }}
              okText="确定"
              cancelText="取消"
            >
              <a type={'link'}>删除</a>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  return (
    <Modal
      title="API直冲商品"
      visible={visible}
      width={800}
      onCancel={() => {
        setVisible(false);
      }}
      destroyOnClose={true}
      footer={false}
    >
      <div>
        <Row justify="space-between">
          <Col>
            <div>
              <Divider
                type="vertical"
                style={{
                  background: '#448ef7',
                  height: 12,
                  width: 4,
                  borderRadius: 4,
                }}
              />
              API商品
            </div>
          </Col>
          <Col>
            <Button
              type="link"
              onClick={() => {
                setCdkeyAddVisable(true);
              }}
            >
              +添加商品
            </Button>
          </Col>
        </Row>
        <Row hidden={!cdkeyAddVisable} justify="left" gutter={10}>
          <Col span={6}>
            <Input
              onChange={(e) => {
                actionRefCdkeyKeyword.current = e.target.value;
              }}
              style={{ width: '100%', height: '32px' }}
              maxLength={24}
              placeholder="请输入"
            ></Input>
          </Col>
          <Col span={13}>
            <DebounceSelect
              labelInValue={false}
              showSearch
              placeholder="支持模糊搜索商品"
              fetchOptions={fetchUserList}
              defaultOptions={allActivitylist}
              onChange={(newValue) => {
                actionRefCdkeyCode.current = newValue;
              }}
              style={{
                width: '100%',
              }}
            />
          </Col>
          <Col span={3}>
            <Space>
              <Button
                type="primary"
                onClick={() => {
                  console.log(
                    'actionRefCdkeyKeyword:',
                    actionRefCdkeyKeyword.current,
                  );
                  console.log(
                    'actionRefCdkeyCode:',
                    actionRefCdkeyCode.current,
                  );
                  bindCdkey();
                }}
              >
                确认
              </Button>
              <Button
                onClick={() => {
                  setCdkeyAddVisable(false);
                }}
              >
                取消
              </Button>
            </Space>
          </Col>
        </Row>
        <br hidden={!cdkeyAddVisable} />
        <ProTable
          columns={cdkeyColumnsPop}
          actionRef={cdkeyActionRef}
          rowKey={() => guuid()}
          search={false}
          scroll={{ x: 'max-content' }}
          toolBarRender={false}
          pagination={{
            defaultPageSize: 5,
          }}
          request={async (params) => {
            const { data, page, code } = await apiGoodsList({
              requestData: {
                ...params,
              },
              page: {
                currentPage: params.current,
                pageSize: params.pageSize,
              },
            });
            if (code !== '00000') {
              return {
                success: false,
              };
            }
            return {
              data: data,
              success: true,
              total: page?.count,
            };
          }}
        />
      </div>
    </Modal>
  );
};
export default channelConfigPage;
